export const GLOBAL_ADMIN_LOCATION = '__GLOBAL__';

